export default function SectionHeader({ eyebrow, title, subtitle, align = "left", testid }) {
    return (
        <div className={`mb-8 md:mb-10 ${align === "center" ? "text-center" : ""}`} data-testid={testid || "section-header"}>
            {eyebrow ? (
                <div className="text-[11px] tracking-[0.36em] uppercase text-orange-300/90 mb-2">{eyebrow}</div>
            ) : null}
            <h2 className="font-display tracking-[0.06em] text-3xl sm:text-4xl lg:text-5xl text-white">
                {title}
            </h2>
            {subtitle ? (
                <p className="mt-3 text-white/70 max-w-2xl leading-relaxed">
                    {subtitle}
                </p>
            ) : null}
            <div className="divider-line mt-6" />
        </div>
    );
}
